import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AccountService } from '@core/services/account/account.service';
import { filter, map, Observable, take } from 'rxjs';
import { AuthLoginService } from '@core/services/auth-login.service';

export const userGuard: CanActivateFn = (): Observable<boolean> => {
  const accountService = inject(AccountService);
  const authLoginService = inject(AuthLoginService);

  return accountService.authState$.pipe(
    filter(state => state !== 'unknown'),
    take(1),
    map(state => {
      if (state === 'authenticated') {
        return true;
      }

      // Не отменяем initial navigation для анонима: Angular откатывает URL к `/`,
      // а нам нужно оставить deep link и показать внешний auth поверх страницы.
      authLoginService.showLogin();

      return true;
    }),
  );
};
